export default __webpack_public_path__ + "static/media/flv.16d0aeba.svg";